<template lang="pug">
    v-card(flat color="transparent" class="m-card__onboard-story")
        v-card-title
            e-typography-heading-1 {{ item.title }}

        v-card-text(class="pa-0")
            e-typography-body-small(class="mb-0 m-accordion-collapse__text_inner" v-html="item.text")
</template>

<script>
    import card from "@mixins/components/modules/cards/concrete/card";
    import MBlockTextReadMore from "@modules/blocks/text/m-block-text-read-more";

    let name = 'm-card-onboard-story';
    export default {
        name: name,
        mixins: [card],
        components: {MBlockTextReadMore},
        props: {
            name: {
                type: String,
                default: name
            },
        },
        computed:{
            visibleTextLines(){
                return this.breakpoints.isMobile? 7 : 10
            }
        }
    }
</script>

<style lang="scss" scoped>
    .m-card {
        &__onboard-story {
            .v-card {
                &__title {

                    @include updatedMedia(sm){

                    }
                }
            }
        }
    }
</style>
